import debug from 'debug';

export const getNamespacedLogger = (namespace: string) => {
  const log = debug(namespace);
  // eslint-disable-next-line no-console
  log.log = console.log.bind(console);
  return log;
};

export const getExtendedLogger = (extension: string, logger: debug.Debugger) =>
  logger.extend(extension);
